import * as React from "react";
import {option} from "ts-option";
import {api} from "../../../api/api";
import Modal from "../../ui/modal/Modal";
import SingleFileSelector from "../../file/SingleFileSelector";
import Toast from "../../helper/Toast";
import {ImportResult} from "../../../model/importResult/ImportResult";
import {notifyBugsnag} from "../../../utils/Utils";


interface IComponentProps {
	/**
	 * On modal close.
	 */
	onClose: () => void;
}

interface IState {
	/**
	 * Indicates if files are uploading
	 */
	filesUploading: boolean;
	/**
	 * Upload errors to display
	 */
	errors: string[];
}

type Props = IComponentProps

export default class UploadJobsModal extends React.PureComponent<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.state = {filesUploading: false, errors: []};
		this.uploadFile = this.uploadFile.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Upload jobs"}>
				<SingleFileSelector onUpload={this.uploadFile}
									onCancel={this.props.onClose}
									errors={option(this.state.errors)}
									filesUploading={this.state.filesUploading}
									onDropValidate={this.onDropValidate}/>
			</Modal>
		);
	}

	onDropValidate = (file: File) => {
		if (file.size > 1048576) {
			this.setState({errors: ["Selected file is too big (over 1MB)"]});
		}
		else {
			this.setState({errors: []})
		}
	}

	uploadFile(file: File) {
		if (file) {
			this.setState({filesUploading: true}, () => {
				api.instance.jobApi.uploadJobs(file).then(() => {
					Toast.success("Jobs uploaded successfully.", "Jobs upload");
					this.setState({filesUploading: false}, this.props.onClose);
				}).catch((error: any) => {
					let errors: string[] = []
					if (error.response) {
						errors = ImportResult.fromJson(error.response.data).error;
					}
					else {
						notifyBugsnag(error);
					}
					this.setState({errors, filesUploading: false});
					Toast.error("Cannot upload jobs.", "Jobs upload");
				});
			});
		}
	}
}

